export enum TaskDifficulty {
  General,
  Easier,
  Harder,
  Unknown,
  Moderate
}



// WEBPACK FOOTER //
// ./src/app/shared/models/task-difficulty.ts